import { FC } from 'react';
import { CustomCard } from '@mybonum/ui';

import { AdminsFilter } from './components/filter';
import { AdminsTable } from './components/table';

export const Admins: FC = () => {
    return (
        <CustomCard>
            <AdminsFilter />
            <AdminsTable />
        </CustomCard>
    );
};
